import { COMPANY_SHORT, ABOUT_IMAGE_URL, PUBLIC_INFO } from '../constants';

function AboutSection() {
  return (
    <section id="about" className="bg-paper">
      <div className="mx-auto grid max-w-6xl gap-12 px-6 py-20 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
        <div>
          <p className="text-xs font-black uppercase tracking-[0.22em] text-ocean">
            Company profile
          </p>
          <h2 className="mt-3 max-w-xl text-4xl font-black uppercase leading-tight tracking-normal text-midnight sm:text-5xl">
            Built from a California LLC filing.
          </h2>
          <p className="mt-5 leading-8 text-muted">
            This page turns the public Articles of Organization details for {COMPANY_SHORT} into a simple, directory-ready web presence. It keeps the profile focused on formation, office location, purpose, and management structure.
          </p>
          <div className="mt-8 grid gap-3">
            {PUBLIC_INFO.map((item) => (
              <div
                key={item.label}
                className="grid gap-2 border-b border-line py-4 sm:grid-cols-[11rem_1fr]"
              >
                <p className="text-[11px] font-black uppercase tracking-[0.2em] text-ocean">
                  {item.label}
                </p>
                <p className="font-semibold text-midnight">{item.value}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="relative overflow-hidden rounded-[1.5rem] border border-line bg-midnight shadow-soft">
            <img
              src={ABOUT_IMAGE_URL}
              alt={`Editorial image representing ${COMPANY_SHORT}`}
              className="h-[520px] w-full object-cover opacity-90"
            />
            <div
              aria-hidden
              className="absolute inset-0 bg-gradient-to-t from-midnight/90 via-midnight/15 to-transparent"
            />
            <div className="absolute inset-x-0 bottom-0 p-7 text-paper">
              <p className="text-[11px] font-black uppercase tracking-[0.24em] text-signal">
                RocketBoss signal
              </p>
              <p className="mt-2 max-w-sm text-2xl font-black uppercase leading-tight">Business identity with a launch-ready feel.</p>
            </div>
        </div>
      </div>
    </section>
  );
}

export default AboutSection;
